<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
          <div class="searchListWrap">
          <div class="searchList">
            <div class="center_text">
            <h5 class="period">조회기간</h5>
              <div class="inBtnWrap">
                <h5 class="period date" v-if="IsWhole">전체조회기간입니다.</h5>
                <h5 class="period date" v-else>{{dateStart}}<b>-</b>{{dateEnd}}</h5>
                <div class="inBtn pre red">
                  <router-link to="./surgeryReservationDate">
                    <button type="button" class="search function">조회하기</button>
                  </router-link>
                </div>
              </div>
            </div>
          <div class="card_wrap">
            <div class="card_list" v-for="s in getSurgeryListArray" :key="s.surgeryCode">
              <div class="cl_title">
                <h2 :class="{white: s.state === '예정'}">{{'수술' + s.state}}</h2>
                <div class="cl_btn">
                  <button v-if="s.state !== '취소' && s.state !== '완료'" type="button" class="red" @click.prevent="applyBtn(s.surgeryCode)">정정요청</button>
                </div>
              </div>
              <div class="cl_content">
                <div class="content_item">
                  <div class="ci_title">
                    <label>수술명</label>
                  </div>
                  <div class="ci_content">
                    <p>{{s.surgeryName}}</p>
                  </div>
                </div>
                <div class="content_item">
                  <div class="ci_title">
                    <label>수술일</label>
                  </div>
                  <div class="ci_content">
                    <p>{{s.surgeryDate | moment('YYYY.MM.DD')}} </p>
                  </div>
                </div>
                <div class="content_item" v-if="s.surgeryDate.substr(11,2) !== '00'">
                  <div class="ci_title">
                    <label>입원시간</label>
                  </div>
                  <div class="ci_content">
                    <p>{{s.surgeryDate | moment('LT')}}</p>
                  </div>
                </div>
                <div class="content_item" v-else>
                  <div class="ci_title">
                    <label>입원시간</label>
                  </div>
                  <div class="ci_content">
                    <p>-</p>
                  </div>
                </div>
                <div class="content_item">
                  <div class="ci_title">
                    <label>의료진</label>
                  </div>
                  <div class="ci_content">
                    <p>{{s.doctorName.name}}</p>
                  </div>
                </div>
              </div>
            </div>
            <p class="notice-comment" v-if="firstDataSet">*입원시간은 추후 변경될 수 있습니다.</p>
          </div>
            <div class="listEmpty" v-if="!firstDataSet">
            <div class="imgWrap">
              <img src="@/assets/images/error.svg">
            </div>
            <div class="ct_content">
              <p>귀하의 수술 일정 기록이 없습니다.</p>
              <p>수술예정 환자의 경우 아래</p>
              <p> &lt;&lt;수술일정 등록요청&gt;&gt; 을 눌러 주시면 확인 후 등록해 드립니다.   </p>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible">
        <button type="button" @click.prevent="applyBtn()">수술일정 등록요청</button>
      </div>
    </div>
    <add-popup v-if="checkPopup" @causeAction="apply()"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import EventBus from '@/utils/bus'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        inputContent: '',
        onInput: true,
        closeType: 'close'
      },
      transDate: {
        headerName: '수술일정조회',
        prevUrl: '/'
      },
      dataFlag: false,
      defaultData: false,
      dateStart: '',
      dateEnd: '',
      IsWhole: '',
      monthDate: '',
      today: '',
      dateMutated: '',
      firstDataSet: false,
      emptyList: false,
      code: '',
      setCount: false,
      getSurgeryListArray: []
    }
  },
  computed: {
    ...mapGetters([
      'getSurgeryDate',
      'getSurgeryList'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_SURGERY_DATE'
    ]),
    ...mapActions([
      'SURGERY_LIST',
      'SURGERY_APPLY'
    ]),
    popupSetter () {
      this.SET_POPUP(true)
      this.popupSet.topImg = false
      if (this.code === undefined) {
        this.popupSet.content = '수술일정 등록요청 요청이 완료되었습니다.'
      } else {
        this.popupSet.content = '수술일정 변경 상담 요청이 완료되었습니다.'
      }
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/surgery/SurgeryReservationList'
    },
    applyBtn (code) {
      this.popupSet.content = '수술일정 등록요청을 요청합니다. 추가 요청 사항이 있으면 기재해주세요.'
      this.popupSet.topImg = true
      this.popupSet.count = 'causeAction'
      this.SET_POPUP(true)
      console.log('code: ', code)
      this.code = code
    },
    async apply () {
      const inputText = document.querySelector('#onInput').value
      const code = this.code
      let requestData
      if (code === undefined) {
        requestData = {
          surgeryCode: null,
          content: inputText
        }
      } else {
        requestData = {
          surgeryCode: code,
          content: inputText
        }
      }
      console.log('requestData: ', requestData)
      try {
        await this.SURGERY_APPLY(requestData)
          .then(() => {
            this.popupSetter()
          })
      } catch (error) {
        console.log('error :', error);
        console.log('수술일정 등록요청 api에서 에러발생.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.count = 'single'
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    // 오늘 ~ 오늘 + 한달 날짜 조회
    getDefaultDate () {
      let date = new Date()
      // let monthDate = date.getTime() - (7 * 24 * 60 * 60 * 1000)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      let dateMutated = new Date(year, month, 0)

      date = this.$moment(date).format('YYYY-MM-DD')
      // monthDate = this.$moment(monthDate).format('YYYY-MM-DD')
      dateMutated = this.$moment(dateMutated).format('YYYY-MM-DD')

      // this.monthDate = monthDate
      this.today = date
      this.dateMutated = dateMutated
    },
    async fetchData () {
      try {
        let requestData
        if (this.dataFlag === false) {
          requestData = {
            gte: null,
            lte: null,
            default: true
          }
        } else {
          requestData = {
            gte: this.dateStart,
            lte: this.dateEnd,
            default: this.IsWhole
          }
        }
        console.log('dataFlag: ', this.dataFlag)
        console.log('requestData: ', requestData)
        await this.SURGERY_LIST(requestData)
          .then(() => {
            this.carryData()
          })
      } catch (error) {
        console.log('error :', error);
        console.log('수술일정 리스트 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    carryData () {
      const getSurgeryListArray = []
      for (let i = 0; i < this.getSurgeryList.length; i++) {
        getSurgeryListArray.push(this.getSurgeryList[i])
      }
      const IsType = typeof (getSurgeryListArray[0])
      console.log('getSurgeryListArray', getSurgeryListArray)
      console.log('getSurgeryListArray.length', getSurgeryListArray.length)
      console.log('getSurgeryListArray[0]', getSurgeryListArray[0])
      console.log('IsType', IsType)
      if (getSurgeryListArray.length >= 1) {
        this.firstDataSet = true
      } else {
        this.firstDataSet = false
      }
      this.getSurgeryListArray = getSurgeryListArray
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    if (this.getSurgeryDate.length >= 1) {
      this.dataFlag = true
      this.dateStart = this.getSurgeryDate[0]
      this.dateEnd = this.getSurgeryDate[1]
      this.IsWhole = this.getSurgeryDate[2]
    } else {
      this.IsWhole = true
      this.dataFlag = false
    }
    this.getDefaultDate()
    this.fetchData()
  },
  mounted () {
    EventBus.$emit('pageAccess', true)
  },
  beforeDestroy () {
    if (this.getSurgeryDate.length >= 1) {
      this.SET_SURGERY_DATE('')
      this.dataFlag = false
    }
    this.setCount = false
    this.SET_POPUP(false)
    EventBus.$off('pageAccess')
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
  p.notice-comment {
    font-size: 0.875rem;
    line-height: 1.57;
    margin: 5px 0 0 0;
  }
</style>
